module.exports = __webpack_public_path__ + "frontend/images/landlords/landlords-letter-0fec4b32446d28bc44f825c91dcf80ed.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/landlords/landlords-letter.png
// module id = 377
// module chunks = 2